import React, { Component, PropTypes } from "react";
import { render } from "react-dom";
import { Navbar } from "react-bootstrap";
import Style from "./css/bootstrap.min.css";

function MyNavBar(params) {
  //console.log(params["conpanyID"]);
  let userType = localStorage.getItem("userType");
  return (
    <div>
      <nav className="navbar-default">
        <div className="container-fluid">
          <div className="navbar-header">
            <button
              type="button"
              className="navbar-toggle"
              data-toggle="collapse"
              data-target="#bs-example-navbar-collapse-1"
              aria-expanded="false"
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
          </div>
          <div
            className="collapse navbar-collapse"
            id="bs-example-navbar-collapse-1"
          >
            {userType == '614a72993114ba2ecdc55d09' ?
              <ul className="nav navbar-nav">
                <li>
                  <a href={"/MyCustomerDeliveryReport/"}>Musteri Teslimat Raporu</a>
                </li>
                <li>
                  <a href={"/myOrdersScreen/"}>Order Management</a>
                </li>
                <li>
                  <a href={"/MyUserManagement/"}>User Management</a>
                </li>
              </ul>
              : ''

            }
            <ul className="nav navbar-nav navbar-right">
              <li>
                <a href="/MyLoginScreen" onClick={() => localStorage.clear()}>Logout</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default MyNavBar;